<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit Product
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.description"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.ratings"
                outlined
                label="Ratings"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.ratings"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="stores"
                outlined
                v-model="form.store_id"
                :items="storeItems"
                label="Store Name"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.store_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.delivery_type"
                :items="deliveryItems"
                label="Delivery Amount"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.delivery_type"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="form.delivery_type == 1">
              <v-text-field
                v-model="form.delivery_amount"
                outlined
                label="Delivery Charges Amount"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.delivery_amount"
              ></v-text-field>
            </v-col>
            <!-- Category -->
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="form.category_id"
                :items="categories"
                label="Category"
                outlined
                item-text="name"
                item-value="id"
                @change="onCategoryChange"
              ></v-autocomplete>
            </v-col>

            <!-- Subcategory -->
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="form.subcategory_id"
                :items="subcategories"
                label="SubCategory"
                outlined
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>
             <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_flash_deal"
                inset
                :label="`Is Flash Deal: ${form.is_flash_deal ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
            <!-- Start date -->
            <v-col sm="4" v-if="form.is_flash_deal">
              <v-menu
                v-model="menu_start"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start_date"
                    label="Start Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.start_date"
                  @input="menu_start = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!-- End date -->
            <v-col sm="4" v-if="form.is_flash_deal">
              <v-menu
                v-model="menu_end"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.end_date"
                    label="End Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.end_date"
                  @input="menu_end = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>

          <section>
            <template
              v-if="
                form &&
                form.product_variants &&
                form.product_variants.length != 0
              "
            >
              <h3 class="my-4">Product Variants:</h3>
              <v-row
                v-for="(variant, variant_index) in form.product_variants"
                :key="`variant${variant_index}`"
              >
                <v-col cols="12">
                  <h3>Product Variant {{ variant_index + 1 }}</h3>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    ref="color"
                    outlined
                    v-model="variant.color"
                    :items="colorItems"
                    label="Color"
                    prepend-inner-icon="mdi-account-tie-outline"
                    clearable
                    :error-messages="
                      errors[`product_variants.${variant_index}.color`]
                    "
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-autocomplete
                    ref="size"
                    outlined
                    v-model="variant.size"
                    :items="sizeItems"
                    label="Size"
                    prepend-inner-icon="mdi-account-tie-outline"
                    clearable
                    :error-messages="
                      errors[`product_variants.${variant_index}.size`]
                    "
                  ></v-autocomplete>
                </v-col>
                <v-col sm="4">
                  <v-text-field
                    v-model="variant.quantity"
                    outlined
                    label="Quantity"
                    prepend-inner-icon="mdi-card-text-outline"
                    :error-messages="
                      errors[`product_variants.${variant_index}.quantity`]
                    "
                  ></v-text-field>
                </v-col>
                <v-col sm="4">
                  <v-text-field
                    v-model="variant.price"
                    outlined
                    label="Price"
                    prepend-inner-icon="mdi-card-text-outline"
                    :error-messages="
                      errors[`product_variants.${variant_index}.price`]
                    "
                  ></v-text-field>
                </v-col>
                <v-col sm="4">
                  <v-text-field
                    v-model="variant.discount_percentage"
                    outlined
                    label="Discount %"
                    prepend-inner-icon="mdi-card-text-outline"
                    :error-messages="
                      errors[
                        `product_variants.${variant_index}.discount_percentage`
                      ]
                    "
                  ></v-text-field>
                </v-col>
                <v-col sm="1">
                  <v-dialog
                    v-model="isDeleteVariantDialogs[variant_index]"
                    max-width="600px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        class="ml-9"
                        small
                        dark
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-close-thick </v-icon>
                      </v-btn>
                    </template>
                    <v-card elevation="10">
                      <v-card-title>
                        <v-icon large color="primary">
                          mdi-information-outline
                        </v-icon>
                        &nbsp; Do you want to remove the variant?
                      </v-card-title>
                      <v-card-text>
                        <v-btn
                          color="primary"
                          @click.stop="deleteVariant(variant_index)"
                        >
                          Yes
                        </v-btn>
                        &nbsp;
                        <v-btn
                          color="red"
                          dark
                          @click.stop="isDeleteVariantDialogs = []"
                        >
                          No
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-col>

                <!-- Images Section -->
                <v-col cols="12">
                  <h4 class="mb-3">
                    Images for Variant {{ variant_index + 1 }}
                  </h4>
                  <v-row
                    v-if="variant && variant.images && variant.images.length"
                  >
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                      v-for="(image, image_index) in variant.images"
                      :key="`variant_${variant_index}_image_${image_index}`"
                    >
                      <v-card outlined class="pa-2">
                        <!-- File Input -->
                        <v-file-input
                          :value="image.fileInput"
                          label="Select Image"
                          outlined
                          dense
                          accept="image/*"
                          hide-details="auto"
                          @change="
                            handleImageUpload(
                              $event,
                              variant_index,
                              image_index
                            )
                          "
                          class="mb-2"
                        ></v-file-input>

                        <!-- Image Preview -->
                        <div class="image-preview-container">
                          <v-img
                            v-if="image.preview_url"
                            :src="image.preview_url"
                            aspect-ratio="1"
                            class="mb-2 rounded"
                            height="150"
                            contain
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>

                          <div v-else class="no-image-placeholder">
                            <v-icon large color="grey"
                              >mdi-image-outline</v-icon
                            >
                            <p class="grey--text">No image selected</p>
                          </div>
                        </div>

                        <!-- Image Status -->
                        <div class="image-status mb-2">
                          <v-chip
                            small
                            :color="image.id ? 'blue' : 'green'"
                            text-color="white"
                            v-if="image.preview_url"
                          >
                            {{
                              image.id
                                ? image.has_new_upload
                                  ? "Updated"
                                  : "Existing"
                                : "New"
                            }}
                          </v-chip>
                        </div>

                        <!-- Actions -->
                        <div class="d-flex justify-space-between">
                          <v-btn
                            icon
                            color="red"
                            @click="
                              removeVariantImage(variant_index, image_index)
                            "
                            title="Remove Image"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>

                          <v-btn
                            v-if="image.preview_url && image.has_new_upload"
                            icon
                            color="orange"
                            @click="
                              clearImageUpload(variant_index, image_index)
                            "
                            title="Cancel Upload"
                          >
                            <v-icon>mdi-undo</v-icon>
                          </v-btn>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Add Image Button -->
                  <v-btn
                    small
                    rounded
                    color="primary"
                    @click="addVariantImage(variant_index)"
                    class="mt-3"
                  >
                    Add More Images
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </template>

            <v-row>
              <v-col sm="12" class="mb-5">
                <v-btn small rounded color="primary" @click="addVariant">
                  Add Variant
                  <v-icon right>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mt-5 mb-5"></v-divider>
          </section>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Product
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "ProductIdPage",
  data() {
    return {
      form: {
        id: null,
        name: "",
        description: "",
        store_id: null,
        delivery_type: 0,
        category_id: null,
        subcategory_id: null,
        product_variants: [],
      },
      isLoading: false,
       is_flash_deal: 0,
      // menu: false,
      menu_start: false,
      menu_end: false,
      colorItems: [],
      sizeItems: [],
      storeItems: [],
      categories: [],
      subcategories: [],
      isDeleteVariantDialogs: [],
      deliveryItems: [
        { text: "FREE DELIVERY", value: 0 },
        { text: "PAID DELIVERY", value: 1 },
      ],
      old_json: null,
      mediaUrl: "https://blr1.vultrobjects.com/space-1/", // Your media base URL
    };
  },

  mounted() {
    this.getData();
    this.fetchCategories();
    this.getMasters();
  },

  methods: {
    async getMasters() {
      try {
        const masters = await axios.get(`masters?context=colorAndsize`);
        const data = masters.data;

        // Handle colors
        data.colors.forEach((color) => {
          this.colorItems.push({
            id: color.id,
            text: color.description,
            value: color.code,
          });
        });

        // Handle sizes
        data.sizes.forEach((size) => {
          this.sizeItems.push({
            id: size.id,
            text: size.description,
            value: size.code,
          });
        });

        // Handle stores
        if (data.stores) {
          data.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.name,
              value: store.id,
            });
          });
        }
      } catch (error) {
        console.error("Error fetching masters:", error);
      }
    },
    async getData() {
      this.isLoading = true;
      const encryptedId = this.$route.params.productId;

      try {
        const response = await axios.get(`/products/${encryptedId}`);
        const productData = response.data.data;

        this.form = {
          ...productData,
          product_variants:
            productData.product_variants?.map((variant) => ({
              ...variant,
              images:
                variant.product_variant_images?.map((img) => ({
                  id: img.id,
                  original_path: img.image_path,
                  preview_url: this.mediaUrl + img.image_path,
                  image_path: null, // Will store new file uploads
                  fileInput: null, // For v-file-input binding
                  has_new_upload: false,
                  is_deleted: false,
                })) || [],
            })) || [],
        };

        // Add at least one empty image slot for each variant if no images exist
        this.form.product_variants.forEach((variant) => {
          if (!variant.images || variant.images.length === 0) {
            variant.images = [this.createEmptyImage()];
          }
        });

        // Handle category/subcategory relationship
        if (this.form.category && this.form.category.parent_id != null) {
          this.form.subcategory_id = this.form.category_id;
          this.form.category_id = this.form.category.parent_id;
          await this.onCategoryChange();
        }

        this.old_json = JSON.parse(JSON.stringify(productData));
        console.log("Loaded form data:", this.form);
      } catch (error) {
        console.error("Error fetching data:", error);
        this.$toast.error("Failed to load product data");
      } finally {
        this.isLoading = false;
      }
    },

    createEmptyImage() {
      return {
        id: null,
        original_path: null,
        preview_url: null,
        image_path: null,
        fileInput: null,
        has_new_upload: false,
        is_deleted: false,
      };
    },

    async fetchCategories() {
      try {
        const response = await axios.get("masters?context=categories");
        this.categories = response.data.categories.filter(
          (category) => category.parent_id === null
        );
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },

    async onCategoryChange() {
      this.subcategories = [];

      if (!this.form.category_id) return;

      try {
        const response = await axios.get(
          `/masters?context=categories&parent_id=${this.form.category_id}`
        );
        this.subcategories = response.data.categories;
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    },

    addVariant() {
      const newVariant = {
        id: null,
        color: "",
        size: "",
        price: "",
        discount_percentage: "",
        quantity: "",
        images: [this.createEmptyImage()],
      };
      this.form.product_variants.push(newVariant);
    },

    deleteVariant(variantIndex) {
      // Clean up any blob URLs before removing variant
      const variant = this.form.product_variants[variantIndex];
      if (variant.images) {
        variant.images.forEach((img) => {
          if (img.preview_url && img.preview_url.startsWith("blob:")) {
            URL.revokeObjectURL(img.preview_url);
          }
        });
      }

      this.form.product_variants.splice(variantIndex, 1);
      this.isDeleteVariantDialogs = [];
    },

    addVariantImage(variantIndex) {
      const variant = this.form.product_variants[variantIndex];
      if (!variant.images) {
        this.$set(variant, "images", []);
      }
      variant.images.push(this.createEmptyImage());
    },

    handleImageUpload(file, variantIndex, imageIndex) {
      const image = this.form.product_variants[variantIndex].images[imageIndex];

      if (file) {
        // Clean up previous blob URL if exists
        if (image.preview_url && image.preview_url.startsWith("blob:")) {
          URL.revokeObjectURL(image.preview_url);
        }

        // Set new file and create preview
        image.image_path = file;
        image.fileInput = file;
        image.preview_url = URL.createObjectURL(file);
        image.has_new_upload = true;
        image.is_deleted = false;

        console.log(
          `Image uploaded for variant ${variantIndex}, image ${imageIndex}:`,
          {
            fileName: file.name,
            fileSize: file.size,
            hasExistingId: !!image.id,
          }
        );
      } else {
        this.clearImageUpload(variantIndex, imageIndex);
      }
    },

    clearImageUpload(variantIndex, imageIndex) {
      const image = this.form.product_variants[variantIndex].images[imageIndex];

      // Clean up blob URL if it exists
      if (image.preview_url && image.preview_url.startsWith("blob:")) {
        URL.revokeObjectURL(image.preview_url);
      }

      // Reset to original state
      if (image.id && image.original_path) {
        // Revert to existing image
        image.image_path = null;
        image.fileInput = null;
        image.preview_url = this.mediaUrl + image.original_path;
        image.has_new_upload = false;
      } else {
        // Clear completely for new images
        image.image_path = null;
        image.fileInput = null;
        image.preview_url = null;
        image.has_new_upload = false;
      }
    },

    removeVariantImage(variantIndex, imageIndex) {
      const image = this.form.product_variants[variantIndex].images[imageIndex];

      // Clean up blob URL
      if (image.preview_url && image.preview_url.startsWith("blob:")) {
        URL.revokeObjectURL(image.preview_url);
      }

      if (image.id) {
        // Mark existing image for deletion
        image.is_deleted = true;
        image.preview_url = null;
        image.fileInput = null;
        image.image_path = null;
      } else {
        // Remove new image completely
        this.form.product_variants[variantIndex].images.splice(imageIndex, 1);
      }
    },

    prepareFormDataForSubmission() {
      const formData = new FormData();

      // Add basic product fields
      Object.keys(this.form).forEach((key) => {
        if (
          key !== "product_variants" &&
          this.form[key] !== null &&
          this.form[key] !== undefined
        ) {
          formData.append(key, this.form[key]);
        }
      });

      // Process variants
      this.form.product_variants.forEach((variant, variantIndex) => {
        // Add variant fields
        Object.keys(variant).forEach((key) => {
          if (
            key !== "images" &&
            variant[key] !== null &&
            variant[key] !== undefined
          ) {
            formData.append(
              `product_variants[${variantIndex}][${key}]`,
              variant[key]
            );
          }
        });

        // Process images for this variant
        if (variant.images) {
          let imageIndex = 0;
          variant.images.forEach((image) => {
            // Skip deleted images
            if (image.is_deleted) return;

            // Add image data
            if (image.id) {
              formData.append(
                `product_variants[${variantIndex}][images][${imageIndex}][id]`,
                image.id
              );
            }

            // Add new file upload
            if (image.image_path instanceof File) {
              formData.append(
                `product_variants[${variantIndex}][images][${imageIndex}][image_path]`,
                image.image_path
              );
            }

            imageIndex++;
          });
        }
      });

      return formData;
    },

    async save() {
      try {
        this.isLoading = true;
        this.errors = {};

        const formData = this.prepareFormDataForSubmission();

        // Debug: Log FormData contents
        console.log("FormData contents:");
        for (let [key, value] of formData.entries()) {
          console.log(
            `${key}:`,
            value instanceof File ? `File: ${value.name}` : value
          );
        }

        const response = await axios.post("/products", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        console.log("Save response:", response.data);

        if (response.data.success) {
          await this.saveUserTimestamp();
          this.$router.back();
        }
      } catch (error) {
        console.error("Save error:", error);

        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
          this.$toast.error("Please fix the validation errors");
        } else {
          this.$toast.error("Failed to update product");
        }
      } finally {
        this.isLoading = false;
      }
    },

    async saveUserTimestamp() {
      try {
        if (!this.user?.id) return;

        const form = {
          from_path: `/products/${this.form.id}`,
          from_name: "ProductIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
      } catch (error) {
        console.log("Timestamp save error:", error);
      }
    },
  },

  beforeDestroy() {
    // Clean up all blob URLs to prevent memory leaks
    if (this.form.product_variants) {
      this.form.product_variants.forEach((variant) => {
        if (variant.images) {
          variant.images.forEach((img) => {
            if (img.preview_url && img.preview_url.startsWith("blob:")) {
              URL.revokeObjectURL(img.preview_url);
            }
          });
        }
      });
    }
  },
};
</script>

<style scoped>
.image-preview-container {
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-image-placeholder {
  text-align: center;
  padding: 20px;
}

.image-status {
  text-align: center;
}

.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08) !important;
}
</style>
